<button
  class="button-primary-label"
  nz-button
  nzBlock
  nzType="primary"
  [disabled]="disabled"
  (click)="onClickButton($event)"
  [style.width]="width"
  [style.background-color]="color"
  [style.color]="color2"
  [style.background]="back"
  [style.border-color]="borderColor"
>
  <h3 class="h3"><ng-content></ng-content></h3>
</button>
